export default "__VITE_ASSET__2ae2edec__"